import React from 'react';
import Scrollbar from 'react-smooth-scrollbar';
import {useSelector} from "react-redux"
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SidebarContent from './SidebarContent';
import { SidebarProps } from '../../../shared/prop-types/ReducerProps';
import {parentNavigation, provderNavigation,adminNavigation,superAdminNavigation,homeNavigations} from "../../../navigation"
import { authRoles } from '../../../config/authroles';

const Sidebar = ({
  changeToDark, changeToLight, changeMobileSidebarVisibility, sidebar,
}) => {
  const sidebarClass = classNames({
    sidebar: true,
    'sidebar--show': sidebar.show,
    'sidebar--collapse': sidebar.collapse,
  });
  const auth = useSelector(state => state.user)
  return (
    <div className={sidebarClass}>
      <button className="sidebar__back" type="button" onClick={changeMobileSidebarVisibility} />
      <Scrollbar className="sidebar__scroll scroll">
        <div className="sidebar__wrapper sidebar__wrapper--desktop">
          {auth && auth.role && (auth.role === authRoles.Parents) && (
             <SidebarContent
             onClick={() => {}}
             changeToDark={changeToDark}
             changeToLight={changeToLight}
             sidebarCollapse={sidebar.collapse}
             sidebarMenu={parentNavigation}
           />
          )}
           {auth && auth.role && (auth.role === authRoles.Provider) && (
             <SidebarContent
             onClick={() => {}}
             changeToDark={changeToDark}
             changeToLight={changeToLight}
             sidebarCollapse={sidebar.collapse}
             sidebarMenu={provderNavigation}
           />
          )}
          {auth && auth.role && (auth.role === authRoles.Admin) && (
             <SidebarContent
             onClick={() => {}}
             changeToDark={changeToDark}
             changeToLight={changeToLight}
             sidebarCollapse={sidebar.collapse}
             sidebarMenu={adminNavigation}
           />
          )}
          {auth && auth.role && (auth.role === authRoles.SuperAdmin) && (
             <SidebarContent
             onClick={() => {}}
             changeToDark={changeToDark}
             changeToLight={changeToLight}
             sidebarCollapse={sidebar.collapse}
             sidebarMenu={superAdminNavigation}
           />
          )}
          {auth && !auth.isAuthenticated &&(
            <SidebarContent
            onClick={() => {}}
            changeToDark={changeToDark}
            changeToLight={changeToLight}
            sidebarCollapse={sidebar.collapse}
            sidebarMenu={homeNavigations}
          />
         )}
         
        </div>
        <div className="sidebar__wrapper sidebar__wrapper--mobile">
        {auth && auth.role && (auth.role === authRoles.Parents) && (
             <SidebarContent
             onClick={changeMobileSidebarVisibility}
             changeToDark={changeToDark}
             changeToLight={changeToLight}
             sidebarCollapse={sidebar.collapse}
             sidebarMenu={parentNavigation}
           />
          )}
          {auth && auth.role && (auth.role === authRoles.Provider) && (
             <SidebarContent
             onClick={changeMobileSidebarVisibility}
             changeToDark={changeToDark}
             changeToLight={changeToLight}
             sidebarCollapse={sidebar.collapse}
             sidebarMenu={provderNavigation}
           />
          )}
          {auth && auth.role && (auth.role === authRoles.Admin) && (
             <SidebarContent
             onClick={changeMobileSidebarVisibility}
             changeToDark={changeToDark}
             changeToLight={changeToLight}
             sidebarCollapse={sidebar.collapse}
             sidebarMenu={adminNavigation}
           />
          )}
          {/* <SidebarContent
            onClick={changeMobileSidebarVisibility}
            changeToDark={changeToDark}
            changeToLight={changeToLight}
          /> */}
        </div>
      </Scrollbar>
    </div>
  );
};

Sidebar.propTypes = {
  sidebar: SidebarProps.isRequired,
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
};

export default Sidebar;
